export default __webpack_public_path__ + "static/media/general-icon.d58229db.svg";